export default class Video {
    private elements: NodeListOf<HTMLElement>;

    constructor(selector: string) {
        this.elements = document.querySelectorAll(selector);
        if (this.elements) {
            this.init();
        }
    }

    private init(): void {
        this.elements.forEach((element: HTMLElement) => {
            const button: HTMLElement = element.querySelector('[data-video-play]');
            if (button) {
                button.addEventListener('click', this.play.bind(this));
            }
        });
    }

    private play(e: Event): void {
        const button = e.target as HTMLElement;
        const block: HTMLElement = button.closest('[data-video]');
        const image: HTMLElement = block.querySelector('[data-video-image]');
        const iframe: HTMLIFrameElement = block.querySelector('[data-video-iframe]');

        iframe.src = `${iframe.src}?autoplay=1`;
        button.classList.add('videos__play--hide');
        image.classList.add('videos__image--hide');
    }
}
